import adminIssuesSlice from './slice';

export const {
  fetchAdminIssues,
  fetchAdminIssuesError,
  fetchAdminIssuesSuccess,
  fetchAdminIssuesSearch,
  putAdminIssuesStatus,
  putAdminIssuesStatusSuccess,
  putAdminIssuesArchiveSaga,
  putAdminIssuesArchiveSuccessSaga,
  fetchAdminIssuesArchivedSuccess,
  fetchAdminIssuesArchived,
} = adminIssuesSlice.actions;
export default adminIssuesSlice.reducer;

export * from './types';
